import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const AuthAdmin: FC = () => {
  const { isAdmin, isLoading } = useAuthContext();

  return <Middleware isLoading={isLoading}>{isAdmin ? <Outlet /> : <Navigate to={Routes.LOGIN} />}</Middleware>;
};

export default AuthAdmin;
